module.exports = __webpack_public_path__ + "img/blogpost1.fa0961f7.jpg";